var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "foot_nav" } }, [
    _c(
      "section",
      {
        staticClass: "foot_item",
        on: {
          click: function($event) {
            _vm.gotoAddress({ path: "/index" })
          }
        }
      },
      [
        _c("img", {
          staticClass: "icon_style",
          attrs: {
            src: _vm._f("indexImg")(
              _vm.$route.path.indexOf("index") !== -1 ||
                _vm.$route.path.length == 1
            )
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "icon-text": true,
              "color-default":
                _vm.$route.path.indexOf("index") >= 0 ||
                _vm.$route.path.length == 1
            }
          },
          [_vm._v("技能培训")]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "section",
      {
        staticClass: "foot_item",
        on: {
          click: function($event) {
            _vm.gotoAddress({ path: "/information" })
          }
        }
      },
      [
        _c("img", {
          staticClass: "icon_style",
          attrs: {
            src: _vm._f("infoImg")(_vm.$route.path.indexOf("information"))
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "icon-text": true,
              "color-default": _vm.$route.path.indexOf("information") >= 0
            }
          },
          [_vm._v("信息公开")]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "section",
      {
        staticClass: "foot_item",
        on: {
          click: function($event) {
            _vm.gotoAddress({ path: "/employment" })
          }
        }
      },
      [
        _c("img", {
          staticClass: "icon_style",
          attrs: {
            src: _vm._f("empImg")(_vm.$route.path.indexOf("employment"))
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "icon-text": true,
              "color-default": _vm.$route.path.indexOf("employment") >= 0
            }
          },
          [_vm._v("就业服务")]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "section",
      {
        staticClass: "foot_item",
        on: {
          click: function($event) {
            _vm.gotoAddress({ path: "/personal" })
          }
        }
      },
      [
        _c("img", {
          staticClass: "icon_style",
          attrs: { src: _vm._f("perImg")(_vm.$route.path.indexOf("personal")) }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "icon-text": true,
              "color-default": _vm.$route.path.indexOf("personal") >= 0
            }
          },
          [_vm._v("个人中心")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-278c512f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-278c512f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer.vue
// module id = null
// module chunks = 